// extracted by mini-css-extract-plugin
export default {"l_video_player_main":"VideoPlayer_l_video_player_main__enZXw","l_video_player__video":"VideoPlayer_l_video_player__video__SDX+8"};